import { render, staticRenderFns } from "./UIFormSocial.vue?vue&type=template&id=20a637d5&"
import script from "./UIFormSocial.vue?vue&type=script&lang=ts&"
export * from "./UIFormSocial.vue?vue&type=script&lang=ts&"
import style0 from "./UIFormSocial.vue?vue&type=style&index=0&id=20a637d5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports